import type { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { getMsalInstance } from './msalInstance';
import React from 'react';

export default function MsalAuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [instance, setInstance] = useState<PublicClientApplication>();

  useEffect(() => {
    getMsalInstance().then(setInstance);
  }, []);

  if (!instance) return null; // or a loading spinner

  return <MsalProvider instance={instance}>{children}</MsalProvider>;
}
